import {useParams} from 'react-router-dom';
import HeaderBasketButton from '../../../../components/headerBasketButton';
import ShareTitleHeader from '../../../../components/mazraeKit/headers/shareTitleHeader';
import NoItemFoundPage from '../../../../components/noItemFoundPage';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetAdLikeStatus from '../../../../services/hookService/getAdLikeStatus/useGetAdLikeStatus';
import useGetDetailShopCard from '../../../../services/hookService/getDetailShopCard/useGetDetailShopCard';
import useGetStoreInputs from '../../../../services/hookService/getStoreInputs/useGetStoreInputGroups';
import usePatchPostLike from '../../../../services/hookService/patchPostLike/usePatchPostLike';
import {groupByField} from '../../../../utilities/helper/groupByField';
import {CategoryList, ICategoryData} from './StoreCategoryItem';

const ShopSelectInputAds = () => {
  const {guid} = useParams();

  const {cardDetailData, isLoading: isShopDetailLoading} = useGetDetailShopCard(
    {guid: guid!},
  );
  const {editLikePost} = usePatchPostLike({
    onSuccessAction: () => {
      refetch();
    },
  });

  const {adLikeStatusData, refetch} = useGetAdLikeStatus(
    guid || '',
    !!guid,
    'stores',
  );

  const {data, isLoading: isInputsLoading} = useGetStoreInputs(guid);

  const isLoading = isShopDetailLoading || isInputsLoading;

  const GroupDataByInputGroup = data && groupByField(data, 'input_group.code');

  return (
    <div className="flex flex-col h-screen ">
      <ShareTitleHeader
        title={cardDetailData?.title || ''}
        isLiked={adLikeStatusData?.like_status || false}
        backRoute={`/shop-card-detail/${guid}`}
        onClickLike={() =>
          cardDetailData?.guid &&
          editLikePost({id: cardDetailData.guid, liking_type: 'stores'})
        }
        isSaleAgent={cardDetailData?.is_sale_agent ?? false}
        rightExtra={<HeaderBasketButton />}
      />
      <section className="p-6">
        {!isLoading && !!!data?.length && (
          <NoItemFoundPage className="h-[80dvh]" />
        )}
        {isLoading ? (
          <div className="flex items-end justify-center">
            <SpinnerLoading />
          </div>
        ) : (
          <>
            <CategoryList
              categories={GroupDataByInputGroup as ICategoryData}
              store={cardDetailData}
            />
          </>
        )}
      </section>
    </div>
  );
};

export default ShopSelectInputAds;
